/**
 * @generated SignedSource<<cf75c3b25bc4f21442b36409d6d3fa33>>
 * @relayHash 0e20b8ae8235a77386843cd13e0e0ba0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0633e4343510cee23e7f7d5bead3fdfd4ceab491801050403e9215a7819d2751

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentBrowseIntentsQuery } from './srcVirtualAgentBrowseIntentsQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentBrowseIntentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0633e4343510cee23e7f7d5bead3fdfd4ceab491801050403e9215a7819d2751",
    "metadata": {},
    "name": "srcVirtualAgentBrowseIntentsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
